import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { CustomCard } from "../../CustomCard";

//styles
import useStyles from "./styles";

function AfterSalesAssignedAgentsCardsSkeleton() {
  const styles = useStyles();
  return (
    <CustomCard
      boxShadow="xs"
      borderRadius="xl"
      borderColor="secondary"
      classes={styles.assignedAgentCard}
    >
      <Box className={styles.upperSection}>
        {/* Badges skeleton */}
        <Box className={styles.badgeSection}>
          <Skeleton
            variant="rect"
            width={60}
            height={24}
            style={{ borderRadius: 12 }}
          />
        </Box>
        {/* Lead ID skeleton */}
        <Skeleton variant="text" width={80} height={24} />
      </Box>
      <Box className={styles.lowerSection}>
        <Box className={styles.avatarWrapper}>
          <Skeleton variant="circle" width={56} height={56} />
        </Box>
        <Box>
          <Skeleton
            variant="text"
            width={120}
            height={28}
            style={{ marginBottom: 8 }}
          />
        </Box>
      </Box>
    </CustomCard>
  );
}

export default AfterSalesAssignedAgentsCardsSkeleton;
